<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0 pt-0">
      <vue-headful title="Benachrichtigungen" description="Aimz"/>
      <header1 class="mt-10">Benachrichtigungen</header1>
      <v-row class="ml-5 mt-5" style="min-height: 40px;" v-if="changed">
        <v-btn dark @click="save">Speichern</v-btn>
        <v-btn class="ml-3" @click="load">Abbrechen</v-btn>
      </v-row>
      <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
      <v-alert type="error" v-if="error">{{ reason }}</v-alert>
      <v-col class="mx-2 mt-3">
        <div class="d-flex">
          <v-checkbox v-model="settings_edited.emailReminderEnabled" label="Erinnnerungsmail"></v-checkbox>
          <v-text-field class="ml-3" v-model="settings_edited.emailReminderAt" label="Täglich ca. um"></v-text-field>
        </div>
        <p class="body-2">
          <span v-if="settings_edited.emailReminderEnabled">
          Die Erinnerungsmail wird ca. um {{ settings_edited.emailReminderAt }} versendet, wenn an diesem Tag noch nichts eingegeben wurde.
          </span>
          <span v-else>
            EMail-Erinnerung ist deaktiviert.
          </span>
        </p>
        <div class="d-flex">
          <v-checkbox v-model="settings_edited.emailReminderAbschlussEnabled" label="Abschlusserinnnerung"></v-checkbox>
          <v-text-field class="ml-3" v-model="settings_edited.emailReminderAbschlussAt" label="Täglich ca. um"></v-text-field>
        </div>
        <p class="body-2">
          <span v-if="settings_edited.emailReminderAbschlussEnabled">
          Die Abschlusserinnerungsmail wird ca. um {{ settings_edited.emailReminderAbschlussAt }} versendet, wenn der Tag noch nicht abgeschlossen wurde.
          </span>
          <span v-else>
            EMail-Abschlusserinnerung ist deaktiviert.
          </span>
        </p>
        <br/>

        <v-divider class="mt-3"></v-divider>

        <div class="d-flex">
          <v-checkbox v-model="settings_edited.emailFirstDaysEnabled" label="Erste 14 Tage Emailhinweise"></v-checkbox>
<!--          <v-text-field class="ml-3" v-model="settings_edited.emailReminderAbschlussAt" label="Täglich ca. um"></v-text-field>-->
        </div>
        <p class="body-2">
          <span v-if="settings_edited.emailFirstDaysEnabled">
            Die Email mit Hinweisen wird die ersten 14 Tage täglich ca. um 12:00 versendet.
          </span>
          <span v-else>
            EMail-Hinweise sind deaktiviert.
          </span>
        </p>
        <br/>

        <v-divider class="mt-3"></v-divider>

        <div class="d-flex">
          <v-checkbox v-model="settings_edited.emailWochenberichtEnabled" label="Wochenbericht"></v-checkbox>
        </div>
        <p class="body-2">
          <span v-if="settings_edited.emailWochenberichtEnabled">
            Die Email mit dem Link zum Wochenbericht wird Montags ca. um 12:15 versendet.
          </span>
          <span v-else>
            Wochenbericht-Email ist deaktiviert.
          </span>
        </p>
        <br/>

        <v-divider class="mt-3"></v-divider>

        <div class="d-flex">
          <v-checkbox v-model="settings_edited.emailJubilaeumEnabled" label="Jubiläumsmail"></v-checkbox>
        </div>
        <p class="body-2">
          <span v-if="settings_edited.emailJubilaeumEnabled">
            Das Gratulationsmail zu verschiedenen Jubiläen wird Montags ca. um 12:00 versendet, wenn du
            isgesamt 5, 10, 25, 50, etc. Wochen lang aktiv warst.
          </span>
          <span v-else>
            Jubiläumsmail ist deaktiviert.
          </span>
        </p>
        <br/>

        <v-divider class="mt-3"></v-divider>

        <div class="d-flex">
          <v-checkbox v-model="settings_edited.emailDranbleibenEnabled" label="Motivationsmail"></v-checkbox>
        </div>
        <p class="body-2">
          <span v-if="settings_edited.emailDranbleibenEnabled">
            Das Motivationsmail wird Montags ca. um 12:00 versendet, wenn du in der vergangenen Woche nicht aktiv warst.
          </span>
          <span v-else>
            Motivationsmail ist deaktiviert.
          </span>
        </p>
        <br/>

        <v-divider class="mt-3"></v-divider>
      </v-col>

      <v-col class="mx-2 mt-3">
        <p v-if="!isGold">
          Für das SMS-Erinnerungsservice bitte auf
          <a class="blue--text text--darken-2" href="https://www.digistore24.com/product/410225" target="_blank">aimz Pro</a>
          upgraden.
        </p>
        <div class="d-flex">
          <v-checkbox v-model="settings_edited.smsReminderEnabled" label="Erinnnerungs-SMS"
                      :disabled="!isGold"></v-checkbox>
          <v-text-field class="ml-3" v-model="settings_edited.smsReminderAt" label="Täglich ca. um"
                        :disabled="!isGold"></v-text-field>
        </div>
        <div class="d-flex">
          <v-text-field class="" v-model="settings_edited.mobileNumber" label="Handynummer"
                        placeholder="+43 677 123456789" :rules="phoneRules" :disabled="!isGold"></v-text-field>
        </div>
        <p class="body-2">
          <span v-if="settings_edited.smsReminderEnabled">
            Die Erinnerungs-SMS wird ab {{ settings_edited.smsReminderAt }} innerhalb von 15min. versendet, wenn an diesem Tag noch nichts eingegeben wurde.
          </span>
          <span v-else>
            SMS-Erinnerung ist deaktiviert.
          </span>
        </p>
      </v-col>

      <div class="d-flex">
        <v-btn class="mr-auto mt-3 mb-3" href="https://youtu.be/6q4Ra2rUkdQ" target="_blank">
          <v-icon class="mr-2">mdi-play-box-outline</v-icon>
          Videoanleitung
        </v-btn>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";

const SETTINGS_CONTEXT = "@settings";

export default {
  name: 'AccountSettings',
  components: {CenterContainer, Header1},
  data() {
    return {
      settings: {},
      settings_edited: {},
      loading: false,
      reason: '',
      error: false,
      changed: false,
      phoneRules: [
        //v => !!v || 'Bitte ausfüllen',
        v => /^\+4\d\s*(\d\s*){6,12}$/.test(v) || 'Ungültige Mobilfunknummer',
      ],
    }
  },
  mounted() {
    if (!this.$app.is_logged_in) {
      this.$store.commit("set", {key: "intern", value: false});
      if (this.$route.path != "/")
        this.$router.replace("/login?returnTo="+this.$route.path);
      return;
    }
    this.$store.commit("set", {key: "intern", value: true});
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$backend.get_settings(SETTINGS_CONTEXT, {onSuccess: this.onLoadSuccess, onError: this.onLoadError});
    },
    onLoadSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onLoadError(reason) {
      this.loading = false;
      this.settings = {};
      this.error = true;
      this.reason = reason;
    },
    save() {
      this.loading = true;
      this.$backend.set_settings(SETTINGS_CONTEXT, this.settings_edited, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError
      });
      this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
  },
  computed: {
    isGold() {
      return this.$app.is_super_user || this.$app.isGold;
    }
  },
  watch: {
    settings_edited: {
      deep: true,
      handler(o, n) {
        this.changed = JSON.stringify(this.settings) !== JSON.stringify(this.settings_edited);
      }
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>